var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavigationUsage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 250,
    viewBox: "0 0 500 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4885_75258)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 250,
    fill: "#2D2F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H54V250H0V0Z",
    fill: "#CCCCCC",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 98,
    y: 48,
    width: 61,
    height: 83,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 98,
    y: 168,
    width: 61,
    height: 83,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 179,
    y: 48,
    width: 61,
    height: 83,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 179,
    y: 168,
    width: 61,
    height: 83,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 260,
    y: 48,
    width: 61,
    height: 83,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 260,
    y: 168,
    width: 61,
    height: 83,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 341,
    y: 48,
    width: 61,
    height: 83,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 341,
    y: 168,
    width: 61,
    height: 83,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 422,
    y: 48,
    width: 61,
    height: 83,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 422,
    y: 168,
    width: 61,
    height: 83,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.8,
    x1: 96,
    y1: 148.5,
    x2: 483,
    y2: 148.5,
    stroke: "#CCCCCC",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4885_75258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationUsage);
export default __webpack_public_path__ + "static/media/navigation-usage.0a20fd59d6005488547c2a8eeaa9cb87.svg";
export { ForwardRef as ReactComponent };